export class DevExtremeUtils {
    private static _devExtremeStyleMode = 'outlined';
    public static get DevExtremeStyleMode() {
        return DevExtremeUtils._devExtremeStyleMode;
    }
    public static set DevExtremeStyleMode(value) {
        if (value != 'filled' && value != 'outlined' && value != 'underlined') {
            console.log(`Invalid style mode ${value}. Valid options are filled, outlined or underlined.`)
        } else {

            DevExtremeUtils._devExtremeStyleMode = value;
            this.dxGlobalItemEditorOptions.stylingMode = value;
        }
    }
    
    public static dxGlobalItemEditorOptions: any = { stylingMode: this.DevExtremeStyleMode };
}